export enum ScoreType {
  AQ = 'AQ',
  PAI = 'PAI',
}
